"use client";

import React from "react";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import ServiceQuoteSection from "@/components/service/ServiceQuoteSection";
import ServiceFormSuccess from "@/components/service/ServiceFormSuccess";
import { inputClass, textareaClass, labelClass, submitClass, formCardClass } from "@/components/service/formStyles";
function ResinboundQuoteForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <ServiceFormSuccess title="Quote Request Sent" message={successMessage || "Thank you for reaching out! We have received your request and will contact you shortly to discuss your resinbound project."} onReset={resetForm} resetLabel="Send Another Request" />;
  }
  return <Form onSubmit={handleSubmit} className={formCardClass}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormField control={control} name="name" rules={{
        required: "Name is required",
        minLength: {
          value: 2,
          message: "Name must be at least 2 characters"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className={labelClass}>Full Name</FormLabel>
              <FormControl>
                <Input placeholder="John Doe" className={inputClass} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "Phone number is required",
        pattern: {
          value: /^[0-9+\s-]{8,}$/,
          message: "Please enter a valid phone number"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className={labelClass}>Phone Number</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="07443 802652" className={inputClass} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Please enter a valid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className={labelClass}>Email Address</FormLabel>
            <FormControl>
              <Input type="email" placeholder="you@example.com" className={inputClass} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Project details are required",
      minLength: {
        value: 10,
        message: "Please provide a bit more detail (min 10 chars)"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className={labelClass}>Project Details</FormLabel>
            <FormControl>
              <textarea placeholder="Tell us about your Southampton resin bound project (e.g. driveway, patio or pathway in SO15 1AA)..." className={textareaClass} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-destructive text-sm font-medium">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className={submitClass}>
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Sending Request...
          </> : "Get Your Free Quote"}
      </Button>
    </Form>;
}
export default function ResinboundQuote() {
  return <ServiceQuoteSection id="get-a-free-quote" eyebrow="GET A FREE QUOTE" heading="Get Your Free Southampton Resin Bound Quote" intro="Contact Firststop Roofing Ltd for a professional assessment of your driveway or patio project. We provide expert advice, site surveys, and transparent pricing for all our resin bound installations in Southampton, Hampshire & surrounding areas." serviceName="Resin Bound">
      <FormProvider formId="start_project_form_get_in_touch" sectionName="GetAFreeQuote" defaultValues={{
      name: "",
      email: "",
      phone: "",
      message: ""
    }} validationRules={{
      name: {
        required: true,
        minLength: 2
      },
      email: {
        required: true,
        pattern: "email"
      },
      phone: {
        required: true
      },
      message: {
        required: true,
        minLength: 10
      }
    }} submitText="Get Your Free Quote" successMessage="Thank you for reaching out! We have received your request and will contact you shortly to discuss your resinbound project.">
        <ResinboundQuoteForm />
      </FormProvider>
    </ServiceQuoteSection>;
}